import { i18n } from '../../ol-street-view';

export const en: i18n = {
    exit: 'Exit',
    exitView: 'Exit Street View mode',
    dragToInit: 'Drag and drop to initialize Google Street View',
    googleMapsLibraryError: 'Google Maps Library is not loaded',
    noImages: 'No images found. Click on the map to move',
    termsOfService: 'Terms of Service',
    expand: 'Expand',
    minimize: 'Minimize'
};
